import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class SessionStateService {
  token: string;
  constructor() { }
  setToken(token: string) {

    
    this.setState("token",token);
    this.token = token;
  }
  getToken(): string {
    return this.getState("token");
  }

  public clearState() {
    
    let persistentKeys = ["source","token"].map(key => {
      let o = {}
      o[key] = sessionStorage[key];
      return o;
    });
    sessionStorage.clear();
    persistentKeys.map(o => Object.keys(o).map(key => sessionStorage[key] = o[key]));
  }
  public setState(key: string, data: any) {
    let session = window["cordova"] ? "localStorage" : "sessionStorage";
    window[session]['setItem'](key, btoa(JSON.stringify(data)));
  }
  public getState(key: string) {
    try {
      let session = window["cordova"] ? "localStorage" : "sessionStorage";
      return JSON.parse(atob( window[session]['getItem'](key)));
    } catch (err) {
      return null;
    }
  }
  public checkForSource() {
    if (!sessionStorage["source"])
      sessionStorage["source"] = this.getParameterByName("source");
  }
  private getParameterByName(name) {
    let url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
}
